import { useEffect, useRef } from "react";
import { gsap, prefersReducedMotion } from "./gsap";

export default function ScrollProgress() {
  const bar = useRef(null);

  useEffect(() => {
    const el = bar.current;
    if (!el || prefersReducedMotion()) return undefined;

    const tween = gsap.fromTo(
      el,
      { scaleX: 0 },
      {
        scaleX: 1,
        ease: "none",
        scrollTrigger: {
          start: 0,
          end: "max",
          scrub: 0.15,
        },
      }
    );

    return () => tween.scrollTrigger?.kill() || tween.kill();
  }, []);

  return <div className="scroll-progress" ref={bar} aria-hidden="true" />;
}
